import React, { memo } from 'react';
import classNames from 'classnames/bind';
import FilterButton from "../../../../FilterButton";
import styles from './ActiveFilters.css';
var cx = classNames.bind(styles);
export var ActiveFilters = /*#__PURE__*/memo(function (_ref) {
  var activeFilters = _ref.activeFilters,
      _onClear = _ref.onClear;
  var isNotConfigured = !activeFilters.length;
  var isMoreFour = activeFilters.length > 3;

  if (isNotConfigured) {
    return /*#__PURE__*/React.createElement(FilterButton, {
      closable: false,
      classes: {
        root: cx('item')
      },
      completed: true
    }, "\u0424\u0438\u043B\u044C\u0442\u0440 \u043D\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043D");
  }

  if (isMoreFour) {
    return /*#__PURE__*/React.createElement(FilterButton, {
      closable: false,
      classes: {
        root: cx('item')
      },
      completed: true
    }, "\u0424\u0438\u043B\u044C\u0442\u0440\u044B: ", activeFilters.length);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, activeFilters.map(function (filter) {
    var _filter$label;

    return /*#__PURE__*/React.createElement(FilterButton, {
      key: filter.value,
      onClear: function onClear() {
        return _onClear(filter.name);
      },
      classes: {
        root: cx('item')
      },
      completed: true
    }, filter.name, ": ", (_filter$label = filter.label) !== null && _filter$label !== void 0 ? _filter$label : filter.value);
  }));
});